import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SubidaDocumentoComponent } from './subida-documento';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SubidaDocumentoComponent],
  imports: [
    SharedModule,
    CommonModule,
  ],
  exports: [
    SubidaDocumentoComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class SubidaDocumentoModule { }
